import React from 'react';

/**
 * Skeleton loader for episode cards
 * Shows animated placeholder while episodes are loading
 */
export const EpisodeSkeleton: React.FC = () => {
  return (
    <article className="episode-card">
      <div className="flex flex-col h-full animate-pulse">
        {/* Thumbnail skeleton */}
        <div className="mb-4 -mt-6 -mx-6 overflow-hidden rounded-t-lg">
          <div className="w-full h-48 bg-gray-800"></div>
        </div>

        {/* Badge skeleton */}
        <div className="flex items-center gap-2 mb-3">
          <div className="h-5 w-20 bg-gray-800 rounded"></div>
          <div className="h-5 w-24 bg-gray-800 rounded"></div>
        </div>

        {/* Title skeleton */}
        <div className="h-7 bg-gray-800 rounded mb-3 w-3/4"></div>

        {/* Excerpt skeleton */}
        <div className="space-y-2 mb-4 flex-1">
          <div className="h-4 bg-gray-800 rounded w-full"></div>
          <div className="h-4 bg-gray-800 rounded w-full"></div>
          <div className="h-4 bg-gray-800 rounded w-2/3"></div>
        </div>

        {/* Metadata skeleton */}
        <div className="flex items-center gap-4 mb-3">
          <div className="h-4 w-24 bg-gray-800 rounded"></div>
          <div className="h-4 w-1 bg-gray-800 rounded"></div>
          <div className="h-4 w-28 bg-gray-800 rounded"></div>
        </div>

        {/* Tags skeleton */}
        <div className="flex flex-wrap gap-2 mb-4">
          <div className="h-6 w-16 bg-gray-800 rounded-full"></div>
          <div className="h-6 w-20 bg-gray-800 rounded-full"></div>
          <div className="h-6 w-14 bg-gray-800 rounded-full"></div>
        </div>

        {/* Button skeleton */}
        <div className="h-6 w-32 bg-gray-800 rounded"></div>
      </div>
    </article>
  );
};

/**
 * Grid of skeleton loaders
 */
export const EpisodeSkeletonGrid: React.FC<{ count?: number }> = ({ count = 6 }) => {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <EpisodeSkeleton key={index} />
      ))}
    </div>
  );
};
